import { render, staticRenderFns } from "./TopicContentStudent.vue?vue&type=template&id=6a21e8e9"
import script from "./TopicContentStudent.vue?vue&type=script&lang=js"
export * from "./TopicContentStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports